import { useCallback, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import useSwr, { mutate } from 'swr';
import toast from 'react-hot-toast';
import Chart from 'react-apexcharts';
import cn from 'clsx';
import ic_arr from '@images/right-arrow-long.png';
// import {
//   Chart as ChartJS,
//   RadialLinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { Radar } from 'react-chartjs-2';
import {
  DeleteVote,
  newWithdrawAllVotesInGroupPoll,
  voteAnother,
  votePoll,
} from '@sdk/managers/VotesManager';

import {
  FormattedPoll,
  getPollVoted,
  getPollPledged,
  VoteItem,
} from '@utils/Poll';

import PollQuestionCard from '@components/modules/Poll/QuestionCard';
import ButtonMighty from '@components/elements/ButtonMighty';
import Notice from '@components/elements/Notice';
import { useAuth } from '@hooks/Auth';
import {
  formatDistanceToNowStrict,
  isFuture,
  isPast,
  format,
  isWithinInterval,
} from 'date-fns';
import PledgeCheckoutForm from '@components/modules/Poll/PledgeCheckoutForm';
import { checkProxyHandlePoll, getGuestData } from '@sdk/managers/UsersManager';
import { Poll, PollStatus } from '@sdk/models';
import { getImageUrl } from '@utils/image';
import { CompanyRole } from '@sdk/API';
import Loader from '@components/elements/Loader';
import { useGlobalContext } from '@context/customContext';
import ConfirmDialog from '@components/elements/ConfirmDialog';
import { symbolName } from 'typescript';
import { createPollComment } from '@sdk/managers/PollsManager';
import InputTextarea from '@components/elements/InputTextarea';

// ChartJS.register(
//   RadialLinearScale,
//   PointElement,
//   LineElement,
//   Filler,
//   Tooltip,
//   Legend
// );

interface PollOptionsFormProps {
  withdrawUrl: string;
  poll?: FormattedPoll | any;
  subPolls?: FormattedPoll[];
  selected: Record<string, string[]>;
  stripe?: any;
  neon?: string;
}

const submitVote = async (
  userId: string,
  optionId: string,
  pollId: string,
  {
    subPollId,
    edit,
    isGuest,
  }: { subPollId?: string; edit?: boolean; isGuest?: boolean } = {}
) => {
  const castVote = edit ? voteAnother : votePoll;
  try {
    return await castVote(
      ['id'],
      pollId,
      subPollId ? subPollId : null,
      userId,
      optionId,
      isGuest || false
    );
  } catch (err: any) {
    // If withdraw will cause error as it counts as no vote but is an update
    const recastVote = edit ? votePoll : voteAnother;
    return recastVote(
      ['id'],
      pollId,
      subPollId ? subPollId : null,
      userId,
      optionId,
      isGuest || false
    );
  }
};

const PollCountDown: React.FC<{ date: Date; title?: string; neon?: boolean }> =
  ({ date, title = 'Poll starts in ', neon = false }) => {
    const [dateStr, setDateStr] = useState<string>();

    useEffect(() => {
      setDateStr(formatDistanceToNowStrict(date));

      const timer = setInterval(() => {
        setDateStr(formatDistanceToNowStrict(date));
      }, 1000);
      // Clear timeout if the component is unmounted
      return () => clearTimeout(timer);
    }, [date, setDateStr]);

    return (
      <>
        {title}
        {dateStr}
      </>
    );
  };

const PollOptionsForm: React.FC<PollOptionsFormProps> = ({
  withdrawUrl,
  poll,
  subPolls,
  stripe,
  selected: propSelected,
  neon,
}) => {
  const history = useHistory<any>();
  const { user, dbUser, company } = useAuth();
  const { themeData, setGuest, guest } = useGlobalContext();
  const [unSelect, setUnselect] = useState<string[]>([]);
  const [textComment, setTextComment] = useState('');
  const [commenting, setCommenting] = useState(false);
  const comment = async () => {
    if (commenting || !textComment.length) return;
    setCommenting(true);
    try {
      var body;
      if (user) {
        body = {
          userID: dbUser?.id,
          name: dbUser?.username,
          pollID: poll.id,
          content: textComment,
        };
      } else {
        const guestId = await setUpGuestId();
        body = {
          userID: guestId,
          name: 'Guest',
          pollID: poll.id,
          content: textComment,
        };
      }

      const res = (await createPollComment(
        ['id', 'name', 'userID', 'pollID', 'createdAt', 'content'],
        body
      )) as any;
      if (res?.data?.result && (poll?.comments as any).items)
        (poll.comments as any).items.unshift(res.data.result);
      console.log(res);
    } catch (error: any) {
      toast.error(error?.message || 'Failed to comment.');
    } finally {
      setTextComment('');
      setCommenting(false);
    }
  };
  let bgColorBtnPledgeCastVote = `${themeData.colors['poll-btnPledgeCastVote-color']}`;
  let borderColorBtnPledgeCastVote = `${themeData.colors['poll-btnPledgeCastVote-borderColor']}`;
  let textColorBtnPledgeCastVote = `${themeData.colors['poll-btnPledgeCastVote-textColor']}`;

  let bgColorBtnEditVote = `${themeData.colors['detailPoll-btnEditVote-color']}`;
  let borderColorBtnEditVote = `${themeData.colors['detailPoll-btnEditVote-borderColor']}`;
  let textColorBtnEditVote = `${themeData.colors['detailPoll-btnEditVote-textColor']}`;

  let bgColorBtnWithdrawVote = `${themeData.colors['detailPoll-btnWithdrawVote-color']}`;
  let borderColorBtnWithdrawVote = `${themeData.colors['detailPoll-btnWithdrawVote-borderColor']}`;
  let textColorBtnWithdrawVote = `${themeData.colors['detailPoll-btnWithdrawVote-textColor']}`;

  let bgColorBtnShowResult = `${themeData.colors['detailPoll-btnResultVote-color']}`;
  let borderColorBtnShowResult = `${themeData.colors['detailPoll-btnResultVote-borderColor']}`;
  let textColorBtnShowResult = `${themeData.colors['detailPoll-btnResultVote-textColor']}`;

  const [isVotePeriod, _setIsVotePeriod] = useState(
    poll &&
      isWithinInterval(new Date(), {
        start: poll?.startDate,
        end: poll?.endDate,
      })
  );

  const setIsVotePeriod = (_isVotePeriod) => {
    if (poll) {
      poll.isVotePeriod = _isVotePeriod;
    }
    _setIsVotePeriod(_isVotePeriod);
  };

  const [isPledgePeriod, _setIsPledgePeriod] = useState(false);

  const setIsPledgePeriod = (_isPledgePeriod) => {
    if (poll) {
      poll.isPledgePeriod = _isPledgePeriod;
    }
    _setIsPledgePeriod(_isPledgePeriod);
  };

  const [voted, setVoted] = useState<boolean>(false);
  const { data: userVote } = useSwr<VoteItem[]>(
    poll ? ['/poll/voted', poll.id, dbUser?.id || guest] : null,
    getPollVoted,
    {
      revalidateOnFocus: true,
      onError: (err, key) => {
        console.log('Failed to fetch user vote', { key }, err);
        // toast.error(err?.message || err?.errors?.[0]?.message);
      },
    }
  );
  const RadaChart = () => {
    const data = {
      series: [
        {
          name: 'Series 1',
          data: [80, 50, 30, 40, 100],
        },
      ],
      options: {
        chart: {
          height: 350,
          type: 'radar',
          foreColor: 'white',
          toolbar: {
            show: true,
            tools: {
              download: false,
            },
          },
        },
        dataLabels: {
          enabled: true,
        },
        colors: ['#FF4560'],
        xaxis: {
          categories: ['January', 'February', 'March', 'April', 'May'],
        },
      } as any,
    };

    return (
      <div className="w-full flex items-center justify-center">
        <Chart
          options={data.options}
          height={Math.min(window.screen.width - 40, 500)}
          series={data.series}
          type="radar"
          width={Math.min(window.screen.width - 40, 500)}
        />
      </div>
    );
  };

  const { data: hasPledge } = useSwr(
    dbUser && poll ? ['/poll/pledged', poll.id, dbUser.id] : null,
    getPollPledged,
    {
      revalidateOnFocus: false,
      onError: (err, key) => {
        console.log('Failed to fetch user pledge', { key }, err);
        toast.error(err.error || err?.message || err?.errors?.[0]?.message);
      },
    }
  );

  const { data: isProxy } = useSwr(
    poll ? ['/poll/isProxy', poll.id, dbUser?.id || guest] : null,
    async (_query: string, pollId: string, userId: string) => {
      if (!company) return false;
      return checkProxyHandlePoll(userId, pollId);
    },
    {
      revalidateOnFocus: false,
      onError: (err, key) => {
        console.log('Failed to fetch current user proxy status', { key }, err);
        toast.error(err?.message || err?.errors?.[0]?.message);
      },
    }
  );

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [showResults, setShowResults] = useState<boolean>(
    poll
      ? [PollStatus.END, PollStatus.PLEDGING1].includes(poll.status) === false
      : false
  );
  const [selected, setSelected] = useState<Record<string, string[]>>(
    propSelected || {}
  );
  const [oldSelected, setOldSelected] = useState<Record<string, string[]>>(
    propSelected || {}
  );

  const questionsCount = 1 + (subPolls?.length || 0);

  const swingVotePermission =
    poll?.owner === dbUser?.username ||
    (company &&
      company.companyID === poll?.companyID &&
      (company?.role === CompanyRole.ADMIN ||
        company.role === CompanyRole.REPRESENTATIVE));

  const proxyPermission =
    company &&
    company.companyID === poll?.companyID &&
    (company?.role === CompanyRole.ADMIN ||
      company.role === CompanyRole.REPRESENTATIVE ||
      isProxy);

  const setUpGuestId = async () => {
    let guestId = '';
    const mightyPollGuest = localStorage.getItem('mighty_poll_guest');
    if (!mightyPollGuest) {
      const data: any = await getGuestData(new Date().valueOf().toString());
      localStorage.setItem(
        'mighty_poll_guest',
        (data && JSON.parse(data)?.id) || ''
      );
      setGuest((data && JSON.parse(data)?.id) || '');
      guestId = (data && JSON.parse(data)?.id) || '';
    }
    if (mightyPollGuest) {
      guestId = mightyPollGuest;
      setGuest(mightyPollGuest);
    }
    return guestId;
  };

  const onSubmit = useCallback(async () => {
    const subPollObj =
      subPolls?.reduce((r, a) => {
        r[a.id] = a;
        return r;
      }, {}) || {};
    if (
      !poll.isNotExact &&
      (!selected[poll.id] ||
        selected[poll.id]?.length <
          (!poll.maxVote || poll.maxVote < 1 ? 1 : poll.maxVote))
    ) {
      console.log('nanana', poll.isNotExact);
      toast.error(
        `You have to vote ${
          !poll.maxVote || poll.maxVote < 1 ? 1 : poll.maxVote
        } options for ${poll.question} question`
      );
      return;
    }
    const notYet = Object.keys(selected)
      .filter((key) => key !== poll.id)
      .find(
        (key) =>
          !selected[key] ||
          selected[key]?.length <
            (!subPollObj[key]?.maxVote || subPollObj[key]?.maxVote < 1
              ? 1
              : subPollObj[key]?.maxVote)
      );
    if (!!notYet && !subPollObj[notYet]?.isNotExact) {
      toast.error(
        `You have to vote ${
          !subPollObj[notYet]?.maxVote || subPollObj[notYet]?.maxVote < 1
            ? 1
            : subPollObj[notYet]?.maxVote
        } options for ${subPollObj[notYet]?.question} question`
      );
      return;
    }

    // if (!user) {
    //   setPolledData({ pselected: selected });
    //   return history.push({
    //     pathname: '/login',
    //     state: { from: window.location.pathname },
    //   });
    // }
    let guestId = '';
    if (!dbUser) {
      guestId = await setUpGuestId();
    }

    if (!poll || !selected || (!dbUser && !guestId)) return;
    setIsSubmitting(true);

    try {
      if (Object.keys(selected).length < questionsCount) {
        throw new Error('You need to select responses for all questions.');
      }
      await newWithdrawAllVotesInGroupPoll(
        dbUser?.id || guestId,
        poll.id,
        null
      );

      await Promise.all(
        Object.keys(selected).map((optionId) => {
          selected[optionId].map((item) => {
            submitVote(dbUser?.id || guestId, item, poll.id, {
              subPollId: optionId === poll.id ? undefined : optionId,
              edit: voted,
              isGuest: guest ? true : false,
            });
          });
          // return submitVote(dbUser.id, selected[optionId], poll.id, {
          //   subPollId: optionId === poll.id ? undefined : optionId,
          //   edit: voted,
          // });
        })
      );

      // Revalidate data
      await new Promise((resolve) => {
        setTimeout(async () => {
          await mutate(['/poll/voted', poll.id, dbUser?.id || guestId]);
          if (voted) {
            await mutate(['/poll/detail', poll.id, user === null]);
          } else {
            // Optimistic update
            await mutate(
              ['/poll/detail', poll.id, user === null],
              (cache) => {
                if (!cache || cache.poll?.voteCount === undefined) return cache;

                // console.log('mutating + 1', {
                //   current: cache.poll.voteCount,
                //   next: cache.poll.voteCount + 1,
                // });

                return {
                  poll: {
                    ...cache.poll,
                    voteCount: cache.poll.voteCount + countModify(),
                  },
                  subPolls: cache.subPolls,
                };
              },
              false
            );
          }

          resolve(true);
        }, 500);
      });

      setVoted(true);
      toast.success(voted ? 'Updated your vote!' : 'Casted your vote!');
      history.replace(`/poll/${poll.id}`);
      setOldSelected(selected);
    } catch (err: any) {
      toast.error(err.message);
    }

    setIsSubmitting(false);

    console.log(selected);
  }, [user, selected, dbUser, history, questionsCount, voted, poll, guest]);

  const currencyFormatter = new Intl.NumberFormat('en-SG', {
    style: 'currency',
    currency: 'SGD',
  });

  useEffect(() => {
    const el = window.document.getElementById('scrollView');
    if (el) {
      const el1 = window.document.getElementById('top1');
      const el2 = window.document.getElementById('bottom1');
      if (el1) {
        el1.style.display =
          el.scrollHeight > el.offsetHeight ? 'block' : 'none';
      }
      if (el2) {
        el2.style.display =
          el.scrollHeight > el.offsetHeight ? 'block' : 'none';
      }
    }
  });

  const scrollTo = (type) => {
    const el = window.document.getElementById('scrollView');
    if (el) {
      el.scrollTop += type === 'top' ? -40 : 40;
    }
  };

  const proxyVoteUrl = `/poll/${poll?.id}/proxy/vote`;

  let actions;
  if (poll && isVotePeriod && !voted) {
    actions = (
      <div
        className={cn('flex flex-col w-full xl:w-auto gap-y-4', {
          'opacity-60': !isVotePeriod,
        })}
      >
        {stripe}
        {!stripe ? (
          <ButtonMighty
            className="w-full xl:w-auto"
            disabled={isSubmitting || !isVotePeriod}
            loading={isSubmitting}
            color={bgColorBtnPledgeCastVote}
            borderColor={borderColorBtnPledgeCastVote}
            textColor={textColorBtnPledgeCastVote}
            text="Cast A Vote"
            neon={neon}
            margin="0"
            onClick={isVotePeriod ? onSubmit : undefined}
          />
        ) : (
          <div>
            <ButtonMighty
              className="w-full xl:w-auto"
              disabled={isSubmitting || !isVotePeriod}
              loading={isSubmitting}
              color={bgColorBtnPledgeCastVote}
              borderColor={borderColorBtnPledgeCastVote}
              textColor={textColorBtnPledgeCastVote}
              text="PLEDGE"
              neon={neon}
              margin="0"
            />
            <RadaChart />
          </div>
        )}

        {proxyPermission && (
          <Link to={proxyVoteUrl}>
            <ButtonMighty
              className="w-full xl:w-auto"
              color={bgColorBtnPledgeCastVote}
              borderColor={borderColorBtnPledgeCastVote}
              textColor={textColorBtnPledgeCastVote}
              text="Cast Proxy Vote"
              neon={neon}
              margin="0"
            />
          </Link>
        )}
      </div>
    );
  } else if (isVotePeriod && voted) {
    actions = (
      <div className="flex flex-col items-center space-y-4">
        <div
          className={cn('w-full xl:w-auto', {
            'opacity-60': !isVotePeriod,
          })}
        >
          <ButtonMighty
            disabled={isSubmitting || !isVotePeriod}
            loading={isSubmitting}
            onClick={isVotePeriod ? onSubmit : undefined}
            color={bgColorBtnEditVote}
            borderColor={borderColorBtnEditVote}
            textColor={textColorBtnEditVote}
            text="Edit my vote"
            neon={neon}
            margin="0"
          />
        </div>

        <div
          className={cn('w-full xl:w-auto', {
            'opacity-60': !isVotePeriod,
          })}
        >
          <Link to={withdrawUrl}>
            <ButtonMighty
              disabled={!isVotePeriod}
              color={bgColorBtnWithdrawVote}
              borderColor={borderColorBtnWithdrawVote}
              textColor={textColorBtnWithdrawVote}
              text="Withdraw vote"
              neon={neon}
              margin="0"
            />
          </Link>
        </div>

        {proxyPermission && (
          <div
            className={cn('w-full xl:w-auto', { 'opacity-60': !isVotePeriod })}
          >
            <Link to={proxyVoteUrl}>
              <ButtonMighty
                disabled={!isVotePeriod}
                color={bgColorBtnPledgeCastVote}
                borderColor={borderColorBtnPledgeCastVote}
                textColor={textColorBtnPledgeCastVote}
                text="Cast Proxy Vote"
                neon={neon}
                margin="0"
              />
            </Link>
          </div>
        )}
      </div>
    );
  } else if (
    poll?.endDate &&
    isPast(poll.endDate) &&
    poll.status !== PollStatus.SWING
  ) {
    actions = (
      <div className="xl:flex">
        <ButtonMighty
          neon={neon}
          color={bgColorBtnShowResult}
          borderColor={borderColorBtnShowResult}
          textColor={textColorBtnShowResult}
          text={showResults ? 'Hide Vote Results' : 'Show Vote Results'}
          margin="0"
          onClick={
            showResults
              ? () => {
                  setShowResults(false);
                }
              : () => {
                  setShowResults(true);
                }
          }
        />
      </div>
    );
  }

  let notice;
  if (poll && poll.status === PollStatus.END && poll.voteCount === 0) {
    notice = <Notice title={`Looks like no one took part in the poll.`} />;
  } else if (poll && poll.status === PollStatus.END && poll.voteCount > 0) {
    notice = <Notice title={`This poll has ended.`} />;
  } else if (
    poll &&
    poll.status !== PollStatus.PLEDGING1 &&
    poll.endDate &&
    isPast(poll.endDate)
  ) {
    notice = (
      <Notice
        title={`Voting has ended! The organiser is processing vote results.`}
      />
    );
  } else if (
    poll &&
    poll.status === PollStatus.PLEDGING1 &&
    poll.pledgePeriod1StartDate &&
    isFuture(poll.pledgePeriod1StartDate)
  ) {
    notice = (
      <Notice
        title={
          <PollCountDown
            title="Pledge starts in "
            date={poll.pledgePeriod1StartDate}
          />
        }
      />
    );
  } else if (
    poll &&
    poll.pledgePeriod1EndDate &&
    isPast(poll.pledgePeriod1EndDate)
  ) {
    notice = (
      <div className="my-5">
        <Notice title={`Pledging period has completed.`} />
      </div>
    );
  } else if (poll && poll.startDate && isFuture(poll.startDate)) {
    notice = <Notice title={<PollCountDown date={poll.startDate} />} />;
  } else if (voted && isVotePeriod) {
    if (
      poll?.pledgePeriod1StartDate &&
      new Date() > poll.pledgePeriod1StartDate
    ) {
      notice = (
        <Notice
          title={`Voting has ended! The organiser is processing vote results.`}
        />
      );
    } else {
      notice = (
        <Notice
          title={
            <>
              You have already voted on this Poll.
              <br />
              <b>Please wait for period to end.</b>
              {!dbUser && (
                <div className="flex flex-col items-center">
                  <div
                    className="mt-2 flex items-center mb-2"
                    style={{ width: 'fit-content' }}
                    onClick={() => history.push(`/login`)}
                  >
                    <div
                      role="button"
                      className="font-semibold text-center font-display mr-4"
                      style={{ color: '#ff1dfc' }}
                    >
                      Have an account?
                    </div>
                    <ButtonMighty
                      disabled={false}
                      loading={false}
                      color="#ff1dfc"
                      neon={neon}
                      text="Log in"
                      borderColor="#00ff43"
                      margin="0"
                      textColor="#fff"
                    />
                  </div>

                  <Link to="/signup">
                    <div
                      role="button"
                      className="font-semibold text-center font-display text-blue"
                    >
                      Don&apos;t have an account? Join MegaX World
                    </div>
                  </Link>
                </div>
              )}
            </>
          }
        />
      );
    }
  }
  const countModify = () => {
    const count =
      Object.keys(selected).reduce((r, a) => {
        r += selected[a].length;
        return r;
      }, 0) -
      Object.keys(oldSelected).reduce((r, a) => {
        r += oldSelected[a].length;
        return r;
      }, 0);
    console.log(count, selected, oldSelected);
    return count;
  };
  useEffect(() => {
    mutate(dbUser && poll ? ['/poll/voted', poll.id, dbUser.id] : null);
  }, [dbUser, history, poll]);

  useEffect(() => {
    if (poll && userVote && userVote.length > 0) {
      const selectedPayload = {};
      userVote.forEach((voteItem) => {
        if (voteItem.subPollID == null) {
          selectedPayload[poll.id] = [
            ...(selectedPayload[poll.id] || []),
            voteItem.option.id,
          ];
        } else {
          selectedPayload[voteItem.subPollID] = [
            ...(selectedPayload[voteItem.subPollID] || []),
            voteItem.option.id,
          ];
        }
      });
      setSelected(selectedPayload);
      setOldSelected(JSON.parse(JSON.stringify(selectedPayload)));
    } else {
      setSelected({});
      setOldSelected({});
    }
    console.log(selected);
    setVoted((userVote?.length || 0) > 0);
  }, [userVote, poll, setSelected, setVoted]);

  useEffect(() => {
    if (!poll) return;

    const timer = setInterval(() => {
      const _isPledgePeriod =
        (poll &&
          poll.pledgePeriod1StartDate &&
          poll.pledgePeriod1EndDate &&
          isWithinInterval(new Date(), {
            start: poll.pledgePeriod1StartDate,
            end: poll.pledgePeriod1EndDate,
          })) ||
        false;

      setIsPledgePeriod(_isPledgePeriod);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [poll, setIsPledgePeriod]);

  useEffect(() => {
    if (!poll) return;

    const timer = setInterval(() => {
      const _isVotePeriod =
        (poll &&
          isWithinInterval(new Date(), {
            start: poll.startDate,
            end: poll.endDate,
          })) ||
        false;

      setIsVotePeriod(_isVotePeriod);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [poll, setIsVotePeriod]);

  useEffect(() => {
    const run = async () => {
      if (poll?.winOption?.detail?.image) {
        poll.winOption.detail.image.url = await getImageUrl(
          poll.winOption.detail.image
        );
      }
    };

    run();
  }, [poll]);

  return (
    <div>
      {notice && <div className="px-8 my-6 space-y-4">{notice}</div>}

      {poll?.status === PollStatus.SWING && dbUser && swingVotePermission && (
        <div className="px-4 pt-4 pb-8 mt-4 mb-4 space-y-4 text-poll-voteResult-status-color bg-poll-voteResult-status-bgColor">
          <div>
            <h3 className="mb-2 text-lg text-poll-voteResult-status-title-color">
              THERE IS A TIE!
            </h3>

            <p>
              Cast a <u>swing vote</u> to determine the winner of the tie.
            </p>

            <div className="mt-8 xl:flex">
              <ButtonMighty
                neon={neon}
                color={bgColorBtnPledgeCastVote}
                borderColor={borderColorBtnPledgeCastVote}
                textColor={textColorBtnPledgeCastVote}
                text="Cast Swing Vote"
                onClick={() =>
                  history.push(`${history.location.pathname}/swing-vote`)
                }
                margin="0"
              />
            </div>
          </div>
        </div>
      )}

      {poll?.status === PollStatus.PLEDGING1 && poll?.winOption && (
        <>
          <div className="px-4 pt-4 pb-8 mt-4 mb-4 space-y-4 text-poll-voteResult-status-color bg-poll-voteResult-status-bgColor">
            <div>
              <h3 className="mb-2 text-lg text-poll-voteResult-status-title-color">
                WINNER
              </h3>

              {poll.winOption.detail?.image?.url && (
                <div className="mb-4">
                  <img src={poll.winOption.detail.image.url} alt="winner" />
                </div>
              )}

              <div
                key={`winner-${poll.winOption.id}`}
                className={cn('flex flex-col w-full')}
              >
                <h3
                  className={cn('text-2xl', {
                    'mb-4': poll.winOption.description !== undefined,
                  })}
                >
                  {poll.winOption.title}
                </h3>

                {poll.winOption.description && (
                  <p
                    className={cn({
                      'text-base': poll.winOption.description.length <= 110,
                      'text-sm': poll.winOption.description.length > 110,
                    })}
                  >
                    {poll.winOption.description}
                  </p>
                )}
                {poll.winOption.detail?.price && (
                  <p>
                    {poll.winOption.detail?.price &&
                      parseFloat(poll.winOption.detail?.price) &&
                      currencyFormatter.format(
                        parseFloat(poll.winOption.detail?.price)
                      )}
                  </p>
                )}
              </div>
              {poll &&
                poll.status === PollStatus.PLEDGING1 &&
                poll.pledgePeriod1StartDate &&
                poll.pledgePeriod1EndDate &&
                isWithinInterval(new Date(), {
                  start: poll.pledgePeriod1StartDate,
                  end: poll.pledgePeriod1EndDate,
                }) &&
                !hasPledge && (
                  <div className="pt-6">
                    <PledgeCheckoutForm pollId={poll.id} neon={neon} />
                  </div>
                )}
              {poll.companyID === company?.companyID && proxyPermission && (
                <div className="mt-4">
                  <Link to={proxyVoteUrl}>
                    <ButtonMighty
                      neon={neon}
                      color={bgColorBtnPledgeCastVote}
                      borderColor={borderColorBtnPledgeCastVote}
                      textColor={textColorBtnPledgeCastVote}
                      text="Pledge for Proxy"
                      margin="0"
                    />
                  </Link>
                </div>
              )}
            </div>
          </div>
          {poll?.pledgePeriod1EndDate &&
            poll?.pledgePeriod1StartDate &&
            isPledgePeriod &&
            hasPledge && (
              <div className="my-5">
                <Notice title="Pledge accepted! The organiser will be in touch!" />
              </div>
            )}
        </>
      )}

      <div className="px-4 pt-4 pb-8 space-y-4 bg-poll-questionCard-bgColor">
        {!poll && (
          <div className="py-12 text-white">
            <Loader spinnerCn="bg-white" title="Fetching vote data..." />
          </div>
        )}

        {poll && showResults && (
          <>
            {poll && (
              <PollQuestionCard
                neon={neon}
                index={1}
                poll={poll}
                vote={selected[poll.id]}
                onSelect={
                  isVotePeriod
                    ? (id: string, type = 'select') => {
                        const maxVote =
                          !poll.maxVote || poll.maxVote < 1 ? 1 : poll.maxVote;

                        if (type === 'select') {
                          if (maxVote === 1) {
                            setSelected({
                              ...selected,
                              [poll.id]: [id],
                            });
                          } else if (
                            !selected[poll.id] ||
                            Object.keys(selected).length === 0 ||
                            selected[poll.id].length < maxVote
                          )
                            setSelected({
                              ...selected,
                              [poll.id]: [...(selected[poll.id] || []), id],
                            });
                        } else {
                          setSelected({
                            ...selected,
                            [poll.id]: selected[poll.id].filter(
                              (item) => item !== id
                            ),
                          });
                        }
                      }
                    : undefined
                }
              />
            )}
            {poll &&
              subPolls
                ?.filter((subPoll) => !!subPoll.id)
                .map((subPoll, index) => {
                  return (
                    <PollQuestionCard
                      key={`subpoll-${subPoll.id}`}
                      index={index + 2}
                      poll={poll}
                      neon={neon}
                      subPoll={subPoll}
                      vote={selected[subPoll.id]}
                      onSelect={(id: string, type = 'select') => {
                        const maxVote =
                          !subPoll.maxVote || subPoll.maxVote < 1
                            ? 1
                            : subPoll.maxVote;
                        if (type === 'select') {
                          if (maxVote === 1) {
                            setSelected({
                              ...selected,
                              [subPoll.id]: [id],
                            });
                          } else if (
                            !selected[subPoll.id] ||
                            Object.keys(selected).length === 0 ||
                            selected[subPoll.id].length < maxVote
                          )
                            setSelected({
                              ...selected,
                              [subPoll.id]: [
                                ...(selected[subPoll.id] || []),
                                id,
                              ],
                            });
                        } else {
                          setSelected({
                            ...selected,
                            [subPoll.id]: selected[subPoll.id].filter(
                              (item) => item !== id
                            ),
                          });
                        }
                      }}
                    />
                  );
                })}
          </>
        )}
        <div className="text-white py-4 my-4" style={{ marginBottom: 150 }}>
          {poll?.comments?.items?.length ? (
            <>
              <p>What People Says...</p>
              <img
                src={ic_arr}
                alt=""
                style={{
                  width: 20,
                  height: 25,
                  margin: '20px auto',
                  transform: 'rotate(-90deg)',
                  cursor: 'pointer',
                }}
                onClick={() => scrollTo('top')}
                id="top1"
              />

              <div
                className="w-full my-4 c-scroll"
                style={{ maxHeight: 350, overflow: 'auto' }}
                id="scrollView"
              >
                {poll.comments.items
                  .sort((a, b) => {
                    return +new Date(b.createdAt) - +new Date(a.createdAt);
                  })
                  .map((item) => (
                    <div className="my-4">
                      <div className="flex items-center justify-between">
                        <p style={{ color: neon }}> {item.name}</p>
                        <p>
                          {format(
                            +new Date(item?.createdAt) || 0,
                            'dd MMM yyyy hh.mm aa'
                          )}
                        </p>
                      </div>
                      <p> {item.content}</p>
                    </div>
                  ))}
              </div>
              <img
                src={ic_arr}
                alt=""
                style={{
                  width: 20,
                  height: 25,
                  margin: '20px auto',
                  transform: 'rotate(90deg)',
                  cursor: 'pointer',
                }}
                onClick={() => scrollTo('bottom')}
                id="bottom1"
              />
            </>
          ) : null}

          <div className="relative mt-4 pt-4">
            <div
              style={{
                position: 'absolute',
                bottom: -48,
                right: 0,
              }}
            >
              {/* <div onClick={() => comment()}>â</div> */}
              <ButtonMighty
                color="#f97075"
                neon={neon}
                text={`Submit`}
                style={!!commenting ? { background: neon } : {}}
                onClick={() => comment()}
                borderColor="#221f20"
                margin="0"
                textColor={neon}
                width="auto"
              />
            </div>
            <InputTextarea
              limitMax
              className="text-xl font-bold border-none"
              placeholder={'This comments will be here'}
              neon={neon}
              value={textComment}
              onKeyDown={(e) => {
                console.log(e);
                if (e.key === 'Enter' && !e.shiftKey) {
                  comment();
                }
              }}
              onChange={(e) => setTextComment(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-4">{actions}</div>
      </div>
    </div>
  );
};

export default PollOptionsForm;
